import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import translation from 'translation';

function getStatPermission (store) {
  if (store.getters['accounts/currentAccount'].type === 'MCC'){
    return ['READ_MCC_STATISTICS'];
  }
  return ['READ_ACCOUNT_STATISTICS'];
}

const accountStatisticsRoutes = [
  {
    path: 'statistics',
    component: NestedRouteComponent,
    children: [
      {
        path: '',
        name: 'accountStatistics',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Statistics')
          },
          permissions: getStatPermission
        },
        component: () => asyncLoadView(import('pages/statistics/StatisticsPage')),
        props: routeArgsToInt
      },
      {
        path: 'detailed',
        name: 'accountDetailedStatistics',
        redirect: {name: 'accountStatistics'}
      }
    ]
  }
];

export default accountStatisticsRoutes;
